import { useFormContext } from 'react-hook-form'

import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

import { BaseFormFields } from '@/components/forms/pricing-interface/BaseSchemaFormFields'
import { SchemaType } from '@/components/forms/pricing-interface/RunRiskForm/RunRiskForm'

export interface RunRiskFormFieldsProps {}

export const RunRiskFormFields: React.FC<RunRiskFormFieldsProps> = ({}) => {
  const { setValue, control, formState, register, watch } = useFormContext<SchemaType>()

  const input_type = watch('input_type')

  return (
    <div className={'@container flex flex-col gap-4'}>
      <FormField
        control={control}
        name="input_type"
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Input Type</FormLabel>
              <SelectInput
                size="sm"
                disabled={formState.isSubmitting}
                value={value}
                onValueChange={(val) =>
                  setValue('input_type', val as 'default_risk' | 'custom_risk', {
                    shouldValidate: true,
                  })
                }
                options={['default_risk', 'custom_risk'].map((v) => ({ label: v, value: v }))}
              />
            </FormItem>
          )
        }}
      />
      <BaseFormFields />
      {input_type === 'custom_risk' && (
        <div className={'grid gap-4 @xs:grid-cols-2'}>
          <FormField
            control={control}
            name="spot"
            render={() => {
              return (
                <FormItem>
                  <FormLabel>Spot</FormLabel>
                  <Input inputSize="sm" {...register('spot')} disabled={formState.isSubmitting} />
                </FormItem>
              )
            }}
          />
          <FormField
            control={control}
            name="vol"
            render={() => {
              return (
                <FormItem>
                  <FormLabel>Vol</FormLabel>
                  <Input inputSize="sm" {...register('vol')} disabled={formState.isSubmitting} />
                </FormItem>
              )
            }}
          />
          <FormField
            control={control}
            name="div"
            render={() => {
              return (
                <FormItem>
                  <FormLabel>Div</FormLabel>
                  <Input inputSize="sm" {...register('div')} disabled={formState.isSubmitting} />
                </FormItem>
              )
            }}
          />
          <FormField
            control={control}
            name="rate"
            render={() => {
              return (
                <FormItem>
                  <FormLabel>Rate</FormLabel>
                  <Input inputSize="sm" {...register('rate')} disabled={formState.isSubmitting} />
                </FormItem>
              )
            }}
          />
          <FormField
            control={control}
            name="time"
            render={() => {
              return (
                <FormItem>
                  <FormLabel>Time</FormLabel>
                  <Input inputSize="sm" {...register('time')} disabled={formState.isSubmitting} />
                </FormItem>
              )
            }}
          />
        </div>
      )}
    </div>
  )
}
